/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.PoleSide = function (draw, lumDownCallBack, poleClickCallBack) {
  var self = this;
  this.draw = draw;
  this.lumDownCallBack = lumDownCallBack;
  this.poleClickCallBack = poleClickCallBack;
  this.resortLums = false;

  this.foundation = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OPolefoundation));
  this.foundationText = draw.text("200mm");
  this.foundationText.font({family: 'Arial', size: 50, leading: '1.0em'}); // jshint ignore:line
  this.foundationText.move(440,6);
  this.foundation.group.add(this.foundationText);
  this.foundation.group.scale(1.5,1.5);


  this.pole = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSMastArray[0]), -1);
  if (poleClickCallBack) {
    this.pole.clickArea.node.style.cursor = 'pointer';
    this.pole.clickArea.on('click', this.poleClickCallBack);
  }

  this.isSelectable = true;

  if (typeof lumDownCallBack === 'undefined' || lumDownCallBack === null) {
    this.isSelectable = false;
  }

  /*
   this.firstAndLastLumSelected = false;
   this.singleSelectedLum = -1;
   */
  this.mastSelected = false;

  this.group = draw.group();
  this.group.add(this.pole.group);

  this.mastSourceIndex = 0;

  this.mastSource = [];

  this.lums = [];
  this.lums[0] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 0, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[1] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 1, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[2] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 2, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[3] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 3, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[4] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 4, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[5] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 5, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[6] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 6, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});
  this.lums[7] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OSGS1Array[0]), 7, this.lumDownCallBack, {clickx: 100, clicky: 0, clickwidth: 600, clickheight:200});

  this.advancedClick = new OLIVIO.NestedSVG(draw, null, -1, this.lumDownCallBack, {clickx: 0, clicky: 0, clickwidth: 600, clickheight:200});
  this.advancedClick.setText(1+"");
  this.advancedClick.setSelected(true);
  //this.advancedClick.circle.hide();
  this.advancedClick.text.fill({color: '#cccccc'});
  // var advancedGrabber = draw.circle(200).stroke({ color: '#000000', width: 2 }).fill({ color: '#000000', opacity: 1.0 });
  //advancedGrabber.move(398,840+40+215*0.5);
  //this.advancedClick.group.add(advancedGrabber);
  //advancedGrabber.back();


  this.advancedClick.group.move(100,0);
  //this.advancedClick.group.hide();


  this.sortArray = [];
  // place pole in middle
  this.pole.displaySort = OLIVIO.getSortFromDegree(91);
  this.sortArray.push(this.pole);
  for (var l = 0; l < this.lums.length; l++) {
    this.lums[l].debugInlay = true;
    this.lums[l].textStaysBlack = true;
    this.lums[l].setText((l+1).toString());
    this.lums[l].textGroup.move(100,0);
    this.sortArray.push(this.lums[l]);
    this.group.add(this.lums[l].group);
    this.lums[l].group.hide();
    this.lums[l].sourceIndex = -1;
    this.lums[l].bracketType = '';
    this.lums[l].lumType = '';
  }

  this.unBindHandlers = function () {
    if (poleClickCallBack) {
      this.pole.clickArea.off('click', this.poleClickCallBack);
    }
    for (var l = 0; l < this.lums.length; l++) {
      this.lums[l].unBindHandlers();
    }
  };

  this.moveLumYBy = function (lumIndex, value) {
    this.lums[lumIndex].group.move(0, this.lums[lumIndex].group.trans.y + value);
  };

  this.moveLumYTo = function (lumIndex, value) {
    if (this.getLumY(lumIndex) === value) {
      return;
    }
    //this.lums[lumIndex].group.animate(100).move(0, value);
    this.lums[lumIndex].group.move(0, value);
  };

  this.lumVisible = function (lumIndex, value) {
    if (value) {
      this.lums[lumIndex].group.show();
    } else {
      this.lums[lumIndex].group.hide();
    }
  };

  this.getLumY = function (lumIndex) {
    return this.lums[lumIndex].group.trans.y;
  };

  this.worldHeight = function () {
    return this.pole.gH;
  };

  this.setLumRotation = function (lumIndex, lumdata) {
    var lumSource = SVG2JS.OSGS1Array;
    if (lumdata.product === OLIVIO.PRODUCT_SISTEMA) {
      if (lumdata.lumType === OLIVIO.LUM_MEDIO) {
        if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA1) {
          lumSource = SVG2JS.OSMS1Array;
        } else if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA2) {
          lumSource = SVG2JS.OSMS2Array;
        } else if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA3) {
          lumSource = SVG2JS.OSMS3Array;
        }
      } else if (lumdata.lumType === OLIVIO.LUM_GRANDE) {
        if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA1) {
          lumSource = SVG2JS.OSGS1Array;
        } else if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA2) {
          lumSource = SVG2JS.OSGS2Array;
        } else if (lumdata.bracketType === OLIVIO.BRACKET_SISTEMA3) {
          lumSource = SVG2JS.OSGS3Array;
        }
      } else if (lumdata.lumType === OLIVIO.LUM_PICCOLO) {
        //piccolo only allowed on bracketType sistema3
        lumSource = SVG2JS.OSPS3Array;
      }
    } else {
      lumSource = SVG2JS.OFLumsArray;
    }


    var svgLum = this.lums[lumIndex];
    var newSource = ((svgLum.lumType !== lumdata.lumType) || (svgLum.bracketType !== lumdata.bracketType));


    var rotation = (lumdata.lumRotationCombined+270) % 360;
    var rotIndex = Math.round(rotation / (360 / lumSource.length));
    // set rotations approximated to 360 degrees to 0 degrees presentation
    if (rotIndex > (lumSource.length - 1)) {
      rotIndex = 0;
    }

    if (svgLum.sourceIndex !== rotIndex) {
      this.resortLums = true;
    }

    // TODO diese Funktion wird zu of aufgerufen
    //console.log('setLumRotation', lumIndex, lumdata.lumType, lumdata.lumRotationCombined, 'rotation: '+rotation+' rotIndex: '+rotIndex +' / ' + lumSource.length, ((svgLum.sourceIndex !== rotIndex) || newSource === true), lumdata, lumdata['lumVisible'], lumdata.lumVisible, typeof(lumdata.lumVisible), lumdata.lumVisible === true, lumdata.lumSelected);

    if ((svgLum.sourceIndex !== rotIndex) || newSource === true) {
      if(!isNaN(rotIndex)) {
        svgLum.updateSVGraw(SVG2JS.getPartSVG(lumSource[rotIndex]));
      } else {
        if(lumdata.lumVisible) {
          console.error('hiding lum with illegal rotIndex: ', lumIndex, lumdata, lumdata.lumVisible, !!lumdata.lumVisible);
          lumdata.lumVisible = false;
        }
      }
      svgLum.sourceIndex = rotIndex;
      svgLum.lumType = lumdata.lumType;
      svgLum.bracketType = lumdata.bracketType;
    }


  };

  /* only rotates if Candelabra */
  this.updatePoleRotation = function (force) {
    console.log('vv updatePoleRotation');

    var rotIndex = 0;
    if (OLIVIO.cmodel.candelabraRotation !== 0) {
      rotIndex = Math.round(OLIVIO.cmodel.candelabraRotation / 5);
    }

    // set rotations approximated to 360 degrees to 0 degrees presentation
    if (rotIndex > (this.mastSource.length - 1)) {
      rotIndex = 0;
    }

    if (this.mastSourceIndex !== rotIndex || force === true) {
      this.pole.updateSVGraw(SVG2JS.getPartSVG(this.mastSource[rotIndex]));
      this.mastSourceIndex = rotIndex;
      this.repaintPole();
    }
    console.log('^^ updatePoleRotation');
  };


  this.updateLums = function () {
    console.log('v--- updateLums' );
    console.log('+--- updateLums', (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA)?'candelabra':'not candelabra');
    self.advancedClick.group.hide();
    if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
      updateSourceCandelabra();
      this.updatePoleRotation(true);
      console.log('^--- updateLums stopped after updateSourceCandelabra');
      return;
    }

    var modellums = OLIVIO.cmodel.getLumieres();
    var colorChange = false;

    this.resortLums = false;
    var lumNumber = 1;
    for (var l = 0; l < OLIVIO.cmodel.maxLums; l++) {
      var modellum = modellums[l];
      console.log('updateLums modellum '+l, modellum);


      this.lums[l].setColor(modellum.colorFill,modellum.colorOutline,modellum.colorFillInlay,modellum.colorFillSelected,modellum.colorOutlineSelected,modellum.colorFillInlaySelected);


      this.moveLumYTo(l, modellum.getLumPositionWorld());
      this.lumVisible(l, modellum.lumVisible);

      if (l === OLIVIO.cmodel.singleSelectedLum && this.isSelectable === true) {
        //this.lums[index].rotateNestedLikeThis(this.advancedClick);
        this.advancedClick.setText(this.lums[l].textValue);
        this.advancedClick.group.move(100,modellum.getLumPositionWorld());
        this.advancedClick.nindex = l;
        this.advancedClick.group.show();
        //this.lums[index].rotateNestedLikeThis(this.advancedClick);
        //this.lums[index].rotateTextLikeThisText(this.advancedClick.textGroup);

        //this.advancedClick.group.rotate(this.lums[index].rotation, 750, 750);
      }

      if (OLIVIO.cmodel.lumsOnOneLevel === false && modellum.lumVisible === true) {
        this.lums[l].setText((lumNumber).toString());
        lumNumber++;
      } else {
        this.lums[l].textGroup.hide();
      }
      if (modellum.sideLumReload === true) {
        //console.log(modellum.lumRotationCombined);
        this.setLumRotation(l, modellum);
        if (this.resortLums === true) {
          this.lums[l].displaySort = OLIVIO.getSortFromDegree(modellum.lumRotationCombined+270);
        }
        modellum.sideLumReload = false;
      }

      this.lums[l].setSelected(
        (OLIVIO.cmodel.firstAndLastLumSelected && (l===0 || l===7)) ||
        (!OLIVIO.cmodel.firstAndLastLumSelected && l === OLIVIO.cmodel.singleSelectedLum)
      );

      this.lums[l].setCursorStyle(!this.mastSelected && (OLIVIO.cmodel.isAdvancedMode() || this.lums[l].selected) ? 'ns-resize' : 'default');
    }

    if (this.resortLums === true) {
      this.sortDisplayOrder();
    }

    this.pole.setCursorStyle(/*OLIVIO.cmodel.isAdvancedMode() ? 'default' :*/ 'pointer'); // FIXME set always to pointer

  };

  this.updateLumsForceRotation = function () {
    var modellums = OLIVIO.cmodel.getLumieres();
    //console.log('updateLumsForceRotation', modellums, modellums.length, modellums[6], modellums[6].lumVisible);
    for (var l = 0; l < OLIVIO.cmodel.maxLums; l++) {
      var modellum = modellums[l];
      //console.log(l+':', modellum, modellum.lumVisible);
      modellum.sideLumReload = modellum.lumVisible; // FIXME nur für sichtbare
    }
    this.updateLums();
  };

  this.sortDisplayOrder = function () {

    this.sortArray.sort(function(a,b) {
        return (a.displaySort < b.displaySort) ? -1 :
          (    (a.displaySort > b.displaySort) ? +1 :
            0 );
      }
    );
    //console.log('/////SORTED TO:');
    for (var i = 0; i < self.sortArray.length; i++) {
      //var nested = self.sortArray[i];
      //console.log(nested.nindex+' '+nested.displaySort);
      this.sortArray[i].group.back();
      // use when pole not grouped
      //this.sortArray[i].group.parent.removeElement(this.sortArray[i].group).add(this.sortArray[i].group, 1);
    }
    self.advancedClick.group.front();

  };

  this.repaintPole = function() {
    var value = OLIVIO.cmodel.mastSelected && !(OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA); // FIXME müsste Mast bei Candelabra nicht immer ausgewählt sein?

    this.pole.setColor(OLIVIO.cmodel.colorMastFill,OLIVIO.cmodel.colorMastOutline,'#ffffff',OLIVIO.cmodel.colorMastFillSelected,OLIVIO.cmodel.colorMastOutlineSelected,'#000000'); // repaints, if color changes
    this.pole.setSelected(value); // forces repaint(); of NestedSVG pole even if nothing changed
  };

  this.repaint = function() {
    this.repaintPole();
    this.updateLums();
  };

  this.setWhite = function () {
    this.pole.setWhiteStrokes();

    for (var i = 0; i < this.lums.length; i++) {
      this.lums[i].setWhiteStrokes();
    }
  };

  var updateSourceCandelabra = function () {
    console.log('v- updateSourceCandelabra');
    //console.log('OLIVIO.cmodel.currentLumCount: '+OLIVIO.cmodel.currentLumCount);
    //console.log('OLIVIO.cmodel.mastSizeIndex: '+OLIVIO.cmodel.mastSizeIndex);
    //console.log('OLIVIO.cmodel.getTopToBottomRotation(): '+OLIVIO.cmodel.getTopToBottomRotation());
    // TODO !h search for all .mastSource

    if (OLIVIO.cmodel.mastSizeIndex === 1) {
      self.pole.group.move(0, 820);
      self.pole.group.scale(3960 / 1363.65, 3960 / 1363.65);

      if (OLIVIO.cmodel.lumType === OLIVIO.LUM_MEDIO) {
        self.pole.group.move(45, 820);
        if (OLIVIO.cmodel.currentLumCount === 1) {
          self.mastSource = SVG2JS.OCM1LUM3000Array;
        } else if (OLIVIO.cmodel.currentLumCount === 2) {
          if (OLIVIO.cmodel.getTopToBottomRotation() === 180) {
            self.mastSource = SVG2JS.OCM2LUM3000D180Array;
          } else {
            self.mastSource = SVG2JS.OCM2LUM3000D120Array;
          }
        } else {
          self.mastSource = SVG2JS.OCM3LUM3000Array;
        }
      } else {
        self.pole.group.move(10, 825);
        if (OLIVIO.cmodel.currentLumCount === 1) {
          self.mastSource = SVG2JS.OCG1LUM3000Array;
        } else if (OLIVIO.cmodel.currentLumCount === 2) {
          if (OLIVIO.cmodel.getTopToBottomRotation() === 180) {
            self.mastSource = SVG2JS.OCG2LUM3000D180Array;
          } else {
            self.mastSource = SVG2JS.OCG2LUM3000D120Array;
          }
        } else {
          self.mastSource = SVG2JS.OCG3LUM3000Array;
        }
      }


    } else {

      self.pole.group.scale(3960 / 1363.65, 3960 / 1363.65);

      if (OLIVIO.cmodel.lumType === OLIVIO.LUM_MEDIO) {
        self.pole.group.move(50, 2);
        if (OLIVIO.cmodel.currentLumCount === 1) {
          self.mastSource = SVG2JS.OCM1LUM4500Array;
        } else if (OLIVIO.cmodel.currentLumCount === 2) {
          if (OLIVIO.cmodel.getTopToBottomRotation() === 180) {
            self.mastSource = SVG2JS.OCM2LUM4500D180Array;
          } else {
            self.mastSource = SVG2JS.OCM2LUM4500D120Array;
          }
        } else {
          self.mastSource = SVG2JS.OCM3LUM4500Array;
        }
      } else {
        self.pole.group.move(10, 5);
        if (OLIVIO.cmodel.currentLumCount === 1) {
          self.mastSource = SVG2JS.OCG1LUM4500Array;
        } else if (OLIVIO.cmodel.currentLumCount === 2) {
          if (OLIVIO.cmodel.getTopToBottomRotation() === 180) {
            self.mastSource = SVG2JS.OCG2LUM4500D180Array;
          } else {
            self.mastSource = SVG2JS.OCG2LUM4500D120Array;
          }
        } else {
          self.mastSource = SVG2JS.OCG3LUM4500Array;
        }
      }


    }

    console.log('^- updateSourceCandelabra');
  };


  this.updateHeight = function () {

    if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_SISTEMA) {


      this.foundationText.text("200mm");
      this.foundation.group.move(90,OLIVIO.cmodel.mastHeightWorldMax-5);
      this.foundation.group.remove(); // do not show in sistema


      // FIXME hier die Breite berücksichtigen, wenn die kleinen Maste für Sistema kommen
      this.pole.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OSMastArray[OLIVIO.cmodel.mastSizeIndex]));


      this.pole.group.move(110, this.pole.group.trans.y);
      if (this.mastSelected === true) {
        this.pole.setSelected(true);
      }
      //this.pole.clickArea.show();

    } else if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_FLORACION) {


      this.foundationText.text("200mm");
      this.foundation.group.move(90,OLIVIO.cmodel.mastHeightWorldMax-5);
      this.foundation.group.remove(); // do not show in floracion

      // FIXME hier die Breite berücksichtigen, wenn die kleinen Metall-Maste für Floracion kommen oder es ein Holzmast ist
      this.pole.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OFMastArray[OLIVIO.cmodel.mastSizeIndex]));
      this.pole.group.move(110, this.pole.group.trans.y);
      //this.pole.clickArea.show();
      if (this.mastSelected === true) {
        this.pole.setSelected(true);
      }

    } else if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {

      this.foundationText.text("800mm");
      this.foundation.group.move(71,OLIVIO.cmodel.mastHeightWorldMax*OLIVIO.cmodel.mastScale);

      updateSourceCandelabra();

      //this.pole.group.move(0,OLIVIO.cmodel.mastHeightWorldMax-OLIVIO.cmodel.mastHeightWorldMax*(OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex]/4500));
      this.updatePoleRotation(true);
      this.pole.clickArea.move(60, 0);
      //this.pole.clickArea.hide();
    }

  };

  this.showAllLums = function (value) {
    for (var i = 0; i < this.lums.length; i++) {
      this.lumVisible(i, value);
    }
  };

};
